import { Link } from "react-router-dom";
import Markdown from "react-markdown";
import privacyMarkdown from "../content/privacy.md?raw";

export default function PrivacyPage() {
  return (
    <div className="hc-page-shell relative min-h-screen w-full overflow-hidden font-sans">
      <div
        className="pointer-events-none absolute left-1/2 top-[40%] size-[320px] -translate-x-[120%] rounded-full bg-hc-warm/15 blur-[64px]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute left-1/2 top-[60%] size-[280px] -translate-x-[20%] rounded-full bg-hc-cool/20 blur-[64px]"
        aria-hidden
      />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-3xl flex-col px-6 py-12">
        <Link
          to="/"
          className="mb-8 inline-flex w-fit items-center gap-2 text-sm text-hc-text-muted transition hover:text-hc-text"
        >
          <i className="icon-arrow-left leading-none" aria-hidden="true" />
          Back to home
        </Link>

        <article className="privacy-content rounded-2xl border border-hc-surface-border bg-hc-surface px-8 py-10 text-hc-text">
          <Markdown>{privacyMarkdown}</Markdown>
        </article>
      </div>
    </div>
  );
}
